const features = [
  {
    id: 1,
    icon: 'ri-hd-line',
    title: '全高清画质',
    desc: '1080P高清片源，清晰细腻不模糊，享受影院级观影体验',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '全球CDN加速节点覆盖，播放流畅零等待，告别卡顿烦恼',
  },
  {
    id: 3,
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '与各大平台同步更新最新剧集，第一时间追到最新剧情',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '多端无缝切换',
    desc: '电脑、平板、手机全平台支持，随时随地接续上次播放',
  },
  {
    id: 5,
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '零弹窗、零强制广告，专注观影不被打扰，沉浸式追剧',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            观影优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            五大核心优势，打造无与伦比的追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((f) => (
            <div
              key={f.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-accent-300/40 transition-colors text-center"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${f.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}